export class Vendordata {

    id: number;
    companyName: string;
    address: string;
    city: string;
    state: string;
    stateId: number;
    country: string;
    countryId: number;
    pinCode: string;
    email: string;
    contactPersonName: string;
    mobileNo: string;
    natureOfBusiness: string;
    natureOfBusinessId: number;
    panNo: string;
    gstRegdNo: string;
    gstRegdAddress: string;
    ntpcOrGeApproved: string;
    ntpcOrGeApprovedId: number;
    executedForNtpcGe: string;
    executedForNtpcGeId: number;
    comments: string;
    cond_1_SustainableDevelop: string;
    cond_2_Confiden_Agreement: string;
    cond_3_GCC: string;
    cond_4_EHS: string;
    cond_5_Erection: string;
    cond_6_LaborWelfare: string;
    sMG_Nos: string;
    sSG_Nos: string;
    vendorType: string;

    //not in prevendor

    applicationNumber : string;
    applicationDate : Date;
    natureOfwork : string;
    natureOfworkId : number;
    nameOfCeoProprietorPartner : string;
    nameofAuthorisedSignatory : string;
    designationOfContactPerson : string;
    sTDCode : string;
    telephoneNo : string;
    typeOfCompany : string;
    typeOfCompanyId : number;
    mSMECategory : string;
    mSMECategoryId : number;
    dateOfIncorporation : Date;
    gSTValidity : Date;
    mSMERegdNo : string;
    mSMEValidity : Date;
    ePFRegdNo : string;
    ePFValidity : Date;
    eSIRegdNo : string;
    eSIValidity : Date;
    bankName : string;
    addressofBank : string;
    location : string;
    iFSCCode : string;
    countryCode : string;
    accountNo : string;
    iSOCertification : string;
    iSOCertificationId : number;
    technicalcollaboration : string;
    rDSetup : string;
    financialYear1 : string;
    salesTurnOver1 : string;
    profitBeforeTax1 : string;
    netWorthCurrency1 : string;
    financialYear2 : string;
    salesTurnOver2 : string;
    profitBeforeTax2 : string;
    netWorthCurrency2 : string;
    financialYear3 : string;
    salesTurnOver3 : string;
    profitBeforeTax3 : string;
    netWorthCurrency3 : string;
    avgTurnOverCurrency : string;
    engineersinManufacturing : number;
    engineersInQA_Inspection : number;
    engineersInAfterSalesService : number;
    engineersInOtherDepartments : number;
    dipHoldersInManufacturing : number;
    dipHoldersInQA_Inspection : number;
    dipHoldersInAfterSalesService : number;
    dipHoldersInOtherDepartments : number;
    othersInManufacturing : number;
    othersInQA_Inspection : number;
    othersInAfterSalesService : number;
    othersInOtherDepartments : number;
    totalEngineers : number;
    totalDiplomaHolders : number;
    totalOtherStuff : number;
    status : string;
    totalTurnover : string;
    authorisedSignatoryEmail : string;
    cEOMobileNo : string;
    cEOTelephone : string;
    authorisedSignatoryDesignation : string;
    authorisedSignatoryMobileNo : string;
    authorisedSignatoryTelephone : string;
    contactPersonDesignation : string;
    contactPersonEmail : string;
    contactPersonMobile : string;
    contactPersonTelephone : string;
    cEOSTDCode : string;
    gSTListStatus : string;
    gSTNos : string;
    enlistedVendor : string;
    accountType : string;
    smgSsg : string;
    smgSsgNos : string;
    smgSsgCount : number;
    vendorNo : number;
    
    // gSTRegArray : string;
    // gSTAddressArray : string;
    // gSTStateArray : string;

    gstRegArray : string;
    gstAddressArray : string;
    gstStateArray : string;

    firstlogin : string;
    userId : string;
    
    vendTotalSteps : number;
    vendCurrentSteps : number;
    vendTotalStepsString : string;
    vendCurrentStepsString : string;
    vendRegisterStatus : string;
    vendEnlistmentStatus : string;
    vendEnlistmentCompeted : boolean;
    isVendorActive : boolean;

    documentType : string;

    changesAllow : boolean;
    isEvaluated : boolean;
     
    currency :string;
    centralSaleTaxNo :string;
    VATRegNo :string;
    companyTaxNo :string;
    competencyParameters :string;
}
